// Initialization Context Store
// This store is used to pass initialization context between pages and components during navigation

const state = {
  conversation: {
    clientUid: null,
    matterUid: null,
    messageTexts: null,
    source: null,
  },
};

const getters = {
  // Getter for conversation data
  getConversation: (state) => () => state.conversation || {},
};

const mutations = {
  // Set data for a specific type
  setData(state, { dataType, data }) {
    state[dataType] = { ...data };
  },

  // Clear data for a specific type
  clearData(state, dataType) {
    state[dataType] = {};
  },
};

const actions = {
  // Action to set data
  setData({ commit }, { dataType, data }) {
    commit('setData', { dataType, data });
  },

  // Action to clear data
  clearData({ commit }, dataType) {
    commit('clearData', dataType);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
